import html2canvas from 'html2canvas';
import utils from 'utils';
class departmentListCtrl {
  constructor(
    $scope,
    $rootScope,
    httpRequest,
    sweetalert,
    $state,
    initSortService,
    $uibModal
  ) {
    $scope.userType = $rootScope.userInfo.user.userType;
    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        orgId: '',
        departmentName: '',
        createUser: '',
      },
    };
    // 分页
    $scope.totalItems = 0; // 组件初始化设置总页数
    // 查询机构信息表
    $scope.queryDepartmentList = function () {
      $scope.queryParam = sessionStorage.departmentListParam
        ? JSON.parse(sessionStorage.departmentListParam)
        : $scope.queryParam;
      httpRequest.post_qryDepartmentList($scope.queryParam).then((res) => {
        $scope.listData = res.data.value.list;
        utils.loaded();
        // 获取后台分页数据 回写分页组件
        $scope.totalItems = res.data.value.total;
        $scope.queryParam.pageNum = res.data.value.pageNum;
      });
    };
    if ($scope.userType != 0) {
      $scope.currentOrgId = $rootScope.userInfo.user.currentOrgId;
      $scope.queryParam.param.orgId = $scope.currentOrgId;
      sessionStorage.setItem(
        'departmentListParam',
        JSON.stringify($scope.queryParam)
      );
      // 设置选中的表
      $scope.queryDepartmentList();
    }

    $scope.reset = function () {
      $scope.queryParam.param.departmentName = '';
      $scope.queryParam.param.createUser = '';
    };

    $scope.search = function () {
      sessionStorage.setItem(
        'departmentListParam',
        JSON.stringify($scope.queryParam)
      );
      $scope.queryDepartmentList();
    };
    $scope.pageChange = function () {
      sessionStorage.setItem(
        'departmentListParam',
        JSON.stringify({
          orderMap: $scope.queryParam.orderMap,
          pageNum: $scope.queryParam.pageNum,
          pageSize: $scope.queryParam.pageSize,
          param: sessionStorage.departmentListParam
            ? JSON.parse(sessionStorage.departmentListParam).param
            : {
                orgId: '',
                departmentName: '',
                createUser: '',
              },
        })
      );
      $scope.queryDepartmentList();
    };

    // 点击查询机构信息表
    $scope.showSelected = function showSelected(node) {
      $scope.currentOrgItem = node;
      $scope.queryParam.param.orgId = node.orgId;
      sessionStorage.setItem(
        'departmentListParam',
        JSON.stringify($scope.queryParam)
      );
      // 设置选中的表
      $scope.queryDepartmentList();
    };
    $scope.tableDropdownConfig = [
      {
        label: '编辑',
        handler(item) {
          $state.go('system.permission.department.edit', {
            departmentId: item.departmentId,
          });
        },
        showWhile(item, hasPermit) {
          return hasPermit('edit_department');
        },
      },
      {
        label: '删除',
        handler(item) {
          sweetalert.confirm('删除确认', '确认删除该部门吗?').then(() => {
            httpRequest
              .get_delDepartment(item.departmentId, '删除部门成功')
              .then((res) => {
                $scope.queryDepartmentList();
              });
          });
        },
        showWhile(item, hasPermit) {
          return hasPermit('del_department');
        },
      },
      {
        label: '查看用户',
        handler(item) {
          let params =
            $scope.userType == 0
              ? { ownerDeptId: item.departmentId, orgIdList: [item.orgId] }
              : { ownerDeptId: item.departmentId };
          let search = encodeURI(JSON.stringify(params));
          return $state.go('system.permission.user.list', { search: search });
        },
        showWhile(item, hasPermit) {
          return hasPermit('view_department_user');
        },
      },
      {
        label: '桌牌二维码',
        handler(item) {
          httpRequest.get_createQrCust(item.departmentId).then((res) => {
            console.log(res);
            $uibModal.open({
              templateUrl: 'createScan.html',
              openedClass: `mod-modal modal-edit-taxpayer-container`,
              animation: true,
              resolve: {
                items1() {
                  return {
                    scanData: res.data.value,
                    departmentName: item.departmentName,
                  };
                },
              },
              controller: [
                '$scope',
                '$uibModalInstance',
                'httpRequest',
                'items1',
                ($scope, $uibModalInstance, httpRequest, items1) => {
                  $scope.modalData = items1.scanData;
                  $scope.departmentName = items1.departmentName;
                  function DownImg(imgUrl, imgName) {
                    if (window.navigator.msSaveOrOpenBlob) {
                      var bstr = atob(imgUrl.split(',')[1]);
                      var n = bstr.length;
                      var u8arr = new Uint8Array(n);
                      while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                      }
                      var blob = new Blob([u8arr]);
                      window.navigator.msSaveOrOpenBlob(
                        blob,
                        imgName + '.' + 'png'
                      );
                    } else {
                      // 这里就按照chrome等新版浏览器来处理
                      const a = document.createElement('a');
                      a.href = imgUrl;
                      a.setAttribute('download', imgName);
                      a.click();
                    }
                  }

                  $scope.ok = () => {
                    html2canvas(document.getElementById('deskCard')).then(
                      function (canvas) {
                        var url = canvas.toDataURL();
                        //生成图片
                        DownImg(
                          url,
                          $scope.modalData.orgName +
                            ' - ' +
                            $scope.modalData.departmentName
                        );
                      }
                    );
                    $uibModalInstance.close();
                  };
                  $scope.cancel = () => {
                    $uibModalInstance.dismiss();
                  };
                },
              ],
            });
          });
        },
        showWhile(item, hasPermit) {
          return true;
        },
      },
    ];
    // 树组件参数
    $scope.treeOptions = {
      nodeChildren: 'children',
      dirSelectable: true,
      allowDeselect: false,
      injectClasses: {
        ul: 'a1',
        li: 'a2',
        liSelected: 'a7',
        iExpanded: 'a3',
        iCollapsed: 'a4',
        iLeaf: 'a5',
        label: 'a6',
        labelSelected: 'a8',
      },
    };

    // //////////////  的控制方法  END   ///////////////
    // 编辑表 需要获取的相关数据
    $scope.toAddPage = () => {
      let orgId = $scope.currentOrgId;
      if ($scope.currentOrgItem) {
        orgId = $scope.currentOrgItem.orgId;
      }
      $state.go('system.permission.department.add', { orgId: orgId });
    };
    // 表头排序
    $scope.orderMap = initSortService('departmentListParam');
    $scope.selectedHandle = function () {
      $scope.queryParam.orderMap = {};
      if ($scope.orderMap.sortKey)
        $scope.queryParam.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal;
      sessionStorage.setItem(
        'departmentListParam',
        JSON.stringify($scope.queryParam)
      );
      $scope.queryDepartmentList();
    };
  }
}
departmentListCtrl.$inject = [
  '$scope',
  '$rootScope',
  'httpRequest',
  'sweetalert',
  '$state',
  'initSortService',
  '$uibModal',
];
export default departmentListCtrl;



// WEBPACK FOOTER //
// ./src/app/system/permission/department/departmentListCtrl.js